<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'des-tipo-veiculo') {
            next({ name: 'des-tipo-veiculo-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'des-tipo-veiculo') {
            this.$router.push({ name: 'des-tipo-veiculo-list' });
        }
    },
};
</script>
